// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1mbsf","choiceBoxes":"toolbarselects_choiceBoxes__JAqcf","simpleField":"toolbarselects_simpleField__3E1zB"};